import { hasOwnProperty } from "@glideapps/ts-necessities";

interface MutationLookup {
    key: string;
    mutator: (val: string) => string;
}

export function isMutationLookup(val: any): val is MutationLookup {
    return typeof val === "object" && hasOwnProperty(val, "key") && hasOwnProperty(val, "mutator");
}

// at runtime this will be looked up and replaced with a value that matches T
export function lookupValue<T = string>(key: string, mutate?: (indexed: string) => string): T {
    if (mutate === undefined) {
        return `_${key}` as unknown as T;
    }

    return {
        key: `_${key}`,
        mutator: mutate,
    } as unknown as T;
}
